// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__An53e","title":"Footer_title__TdYhW","socials":"Footer_socials__h4Nth"};